import '../../styles.global.css';
import '../../assets/styles/Page.module.css';

var styles = {"baseFont":"wru__Page__baseFont","wrapper":"wru__Page__wrapper","baseColor":"wru__Page__baseColor","baseFontFamily":"wru__Page__baseFontFamily","header":"wru__Page__header","item":"wru__Page__item","image":"wru__Page__image","icon":"wru__Page__icon","clan_blitz_logo":"wru__Page__clan_blitz_logo","clan_battle_logo":"wru__Page__clan_battle_logo","content":"wru__Page__content","title":"wru__Page__title","description":"wru__Page__description"};

export { styles as default };
//# sourceMappingURL=Page.module.scss.js.map
